import { Config } from '.';

const config: Config = {
    API_URL: 'https://api.decathlon.madeatsilverchip.com',
};

export default config;
